import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { authService } from 'services';
import { PermissionMapModel, UserModel, UserSettings } from 'models';

export interface ProfileState {
  loading: boolean;
  profile: UserModel | null;
}

const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    profile: null,
    loading: false,
  } as ProfileState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setProfile: (state, action: PayloadAction<UserModel | null>) => {
      state.profile = action.payload;
      state.loading = false;
    },
    clearProfile: (state) => {
      state.profile = null;
      state.loading = false;
    },
    setProfileSettings: (state, action: PayloadAction<UserSettings>) => {
      if (state.profile?.settings) {
        state.profile.settings = action.payload;
      }
    },
  },
});

const { actions } = profileSlice;

export const profileReducer = profileSlice.reducer;
export const { clearProfile, setProfileSettings } = actions;

export const getProfile = () => async (dispatch: AppDispatch) => {
  dispatch(actions.setLoading(true));

  const profile = await authService.getProfile();

  dispatch(actions.setProfile(profile || null));

  return profile;
};

export const selectProfile = (state: ApplicationState) => {
  return state.profile.profile;
};

const NO_PERMISSIONS: PermissionMapModel = {};

export const selectUserPermissions = (state: ApplicationState): PermissionMapModel => {
  return selectProfile(state)?.permissions ?? NO_PERMISSIONS;
};

